import { showErrorResponse } from "../../app/utils/common/Functions";
import { showSuccessToast } from "../../app/utils/common/Toast";
import { isMonthlyAccessBlockedError } from "../../app/utils/common/monthlyAccessBlockedError";
import {
  getAllTasksAPI,
  createTaskAPI,
  updateTaskAPI,
  getTasksByDateRangeAPI,
  getWorkingHourAPI,
  getFilterTaskAPI,
} from "../Apis/taskApi";

export const taskReducer = (builder) => {
  builder
    .addCase(getAllTasksAPI.pending, (state) => {
      state.loading = true;
    })
    .addCase(getAllTasksAPI.fulfilled, (state, action) => {
      state.loading = false;
      state.tasks = action.payload.data;
      state.isTaskUpdated = false;
    })
    .addCase(getAllTasksAPI.rejected, (state, action) => {
      state.loading = false;
      showErrorResponse(action.payload);
    })
    .addCase(getTasksByDateRangeAPI.pending, (state) => {
      state.loading = true;
    })
    .addCase(getTasksByDateRangeAPI.fulfilled, (state, action) => {
      state.loading = false;
      const payload = action.payload?.data;
      if (payload && typeof payload === "object" && payload.tasks != null) {
        state.calendarTasks = payload.tasks ?? {};
        state.calendarLeaveByDate = payload.leaveByDate ?? {};
        state.calendarPublicHolidaysByDate = payload.publicHolidaysByDate ?? {};
      } else {
        state.calendarTasks = payload ?? {};
        state.calendarLeaveByDate = {};
        state.calendarPublicHolidaysByDate = {};
      }
      state.isTaskUpdated = false;
    })
    .addCase(getTasksByDateRangeAPI.rejected, (state, action) => {
      state.loading = false;
      showErrorResponse(action.payload);
    })
    .addCase(createTaskAPI.pending, (state) => {
     
    })
    .addCase(createTaskAPI.fulfilled, (state) => {
      showSuccessToast("Task created successfully.");
      state.isTaskUpdated = true;
    })
    .addCase(createTaskAPI.rejected, (state, action) => {
      // Access-request popup is shown by Apply-Hours-Drawer for this error.
      if (isMonthlyAccessBlockedError(action.payload)) return;
      showErrorResponse(action.payload);
    })
    .addCase(updateTaskAPI.pending, (state) => {
      state.loading = true;
    })
    .addCase(updateTaskAPI.fulfilled, (state) => {
      state.loading = false;
      state.isTaskUpdated = true;
    })
    .addCase(updateTaskAPI.rejected, (state, action) => {
      state.loading = false;
      showErrorResponse(action.payload);
    })
    .addCase(getWorkingHourAPI.pending, (state) => {
      state.workingHours.loading = true;
    })
    .addCase(getWorkingHourAPI.fulfilled, (state, action) => {
      state.workingHours.loading = false;
      const payload = action.payload?.data;
      if (payload && typeof payload === "object" && "workingHours" in payload) {
        state.workingHours.data = payload;
      } else if (typeof payload === "number") {
        state.workingHours.data = { workingHours: payload, leave: null };
      } else {
        state.workingHours.data = { workingHours: 8, leave: null };
      }
    })
    .addCase(getWorkingHourAPI.rejected, (state, action) => {
      state.workingHours.loading = false;
      showErrorResponse(action.payload);
    })
    .addCase(getFilterTaskAPI.pending, (state) => {
      state.loading = true;
    })
    .addCase(getFilterTaskAPI.fulfilled, (state, action) => {
      state.loading = false;
      const payload = action.payload?.data;
      if (payload && typeof payload === "object" && payload.tasks != null) {
        state.filteredTasks = payload.tasks ?? {};
      } else {
        state.filteredTasks = payload ?? {};
      }
    })
    .addCase(getFilterTaskAPI.rejected, (state, action) => {
      state.loading = false;
      state.filteredTasks = {};
      showErrorResponse(action.payload);
    });
};
